interface iContent {
  file_name: string;
  presigned_url: string;
  status: string;
  title: string;
  origin: string;
}


export const historyOptionsType = [
  "Publicado",
  "Excluido",
  "Modificado",
  "Revogado",
  "Fixado",
  "Desfixado",
  "Descrição alterada",
  "Posição alterada",
  "Agendado",
  "Incluído"
]


/** Valor do Select para “Todos”; não deve ser enviado como filtro na API. */
export const FILTER_ALL_SELECT_VALUE = "Todos";

export const optionsType = [
  "Ato",
  "Deliberação",
  "Lei",
  "Manifestação",
  "Orientação",
  "Parecer Referencial",
  "Portaria",
  "Provimento",
  "Resolução",
  "Súmula",
];


export const optionsOrigin = [
  "Assessoria Jurídico-Legislativa",
  "Conselho",
  "Corregedoria-Geral",
  "Defensor Público-Geral",
  "Outros",
];


export const REGULATION_EMPHASIS_WORD = "ATOS";

export const regulationTooltipText =
  "ATOS é o repositório oficial de atos administrativos da Defensoria Pública de Santa Catarina, em que contém resoluções, deliberações, portarias, provimentos e orientações, e permitindo sua pesquisa e a rápida identificação de seu status (vigente, vigente com alterações ou revogado)";

export const regulation = `${REGULATION_EMPHASIS_WORD} é o repositório oficial de atos administrativos da Defensoria Pública de Santa Catarina...`;

export function formatDateFromObject(date: any) {
  const day = date.day < 10 ? `0${date.day}` : date.day;
  const month = date.month < 10 ? `0${date.month}` : date.month;
  return `${day}-${month}-${date.year}`;
}


export function formatDateUTC(dateString: string) {
  const [year, month, day] = dateString.split("-");
  return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
}


export function handleKeyPress(
  event: any,
  handleSubmit: any,
  key: string,
  different?: string | string[]
) {
  const differentArray = Array.isArray(different) ? different : [different];

  if (event.key === key && !differentArray.includes(event.target.name)) {
    handleSubmit();
  }
}


export function handleExtract(data: iContent[], setContent: any) {
  data?.forEach((content: iContent) => {
    const parts = content?.file_name?.split("---");
    let date = "";
    let edition = "";
    let hour = "";

    parts.forEach((part) => {
      if (part.startsWith("date=")) {
        date = part.split("=")[1].replace(/-/g, "/");
      } else if (part.startsWith("hour=")) {
        hour = part.split("=")[1];
      } else if (part.startsWith("file=")) {
        edition = part
            .split("=")[1]
            .replace(".html", "")
            .replace("_", " ")
            .replace("nº", "nº ");
      }
    });

    if (date) {
      const extractedHour = new Date(
          `${date.split("/")[1]}/${date.split("/")[0]}/${date.split("/")[2]} ${hour}`
      );
      if (extractedHour < new Date()) {
        const extractedInfo = {
          date,
          edition,
          hour,
          presigned_url: content.presigned_url,
          url: content.presigned_url,
          fileKey: content.file_name,
          status: content.status.charAt(0).toUpperCase() + content.status.slice(1).toLowerCase(),
          title: content.title,
          origin: content.origin || "-",
        };

        setContent((prev: any) => [...prev, extractedInfo]);
      }
    }
  });
}


export function returnHandleExtractUrl(url: string): string {
  try {
    const u = new URL(url);
    let path = decodeURIComponent(u.pathname);

    const idx = path.indexOf('/posts/');
    if (idx !== -1) {
      path = path.slice(idx + '/posts/'.length);
    } else {
      path = path.replace(/^\/+/, '');
    }

    const lower = path.toLowerCase();
    const htmlIdx = lower.indexOf('.html');
    if (htmlIdx !== -1) return path.slice(0, htmlIdx + 5);

    const htmIdx = lower.indexOf('.htm');
    if (htmIdx !== -1) return path.slice(0, htmIdx + 4) + 'l';

    return path;
  } catch {
    const m = url.match(/posts\/([^?]+)/i);
    if (m) {
      let key = decodeURIComponent(m[1]);
      const lower = key.toLowerCase();
      const htmlIdx = lower.indexOf('.html');
      if (htmlIdx !== -1) return key.slice(0, htmlIdx + 5);
      const htmIdx = lower.indexOf('.htm');
      if (htmIdx !== -1) return key.slice(0, htmIdx + 4) + 'l';
      return key;
    }
    return "";
  }
}


export function sanitizeInput (input : string): string {
    return input.replace(/[<>]/g, "");
}


export const maxLenght = 50;


export function logGroup(type: string, data: any) {
  console.groupCollapsed(type);
  console.groupEnd();
}


export function formatFileName(fileName: any) {
  const namePart = fileName.split('---file=')[1].replace("_", " ").replace("nº", "nº ");
  const originPart = fileName.split('origin=')[1].split('---')[0]
  const datePart = fileName.split('date=')[1].split('---')[0]
  // const day = datePart.split('-')[0];
  // const month = datePart.split('-')[1];
  const year = datePart.split('-')[2];
  return namePart ? namePart.replace('.html', ` ${year} do(a) ${originPart}`).replace("nº", "nº ") : '';
}